import { defineFcm } from '../shared/factory';

export const FCM_DISABLE_ADMIN_LOGIN = defineFcm('disable_admin_login')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform',
		scope: ['corgi-middle-end', 'QAA'],
		context: 'Security / Authentication',
		description: `If this FC is set to true, then users with any staff/admin roles are unable to login to the site with any method aside from OneLogin SSO.

		It's been enabled on Prod as a security feature, but we want it disabled on Staging & Demo envs so that we can get into our test accounts`,
	});
